import*as t from"react";const e=t.createContext(!1),o=()=>t.useContext(e);e.Provider;export{o as useIsRestoring};
